import { Watermark } from '@src/modules/players/shared/interfaces/player-configs.interface';
import { debounceTime, fromEvent } from 'rxjs';
import { moveWatermark } from './move-watermark';
import { checkWatermark } from '@root/private/js/common/watermark/detect-watermark-deletion';
import { drawWatermark } from '@root/private/js/common/watermark/draw-watermark';
import isMobileUtil from 'is-mobile';

const addWatermark = (
  playerEl: HTMLDivElement,
  label: string,
  option?: Watermark,
) => {
  const { fontSize = 16 } = option;

  drawWatermark(option, label, playerEl);

  const watermarkEls = document.querySelectorAll('.watermark');

  watermarkEls.forEach((watermarkEl: HTMLDivElement) => {
    checkWatermark(playerEl, watermarkEl);
  });

  jwplayer().on('fullscreen', ({ fullscreen }) => {
    watermarkEls.forEach((watermarkEl: HTMLDivElement) => {
      const base = parseFloat(
        (watermarkEl as HTMLElement).dataset.baseFontSize || `${fontSize}`,
      );
      if (fullscreen) {
        watermarkEl.style.fontSize = base * 1.25 + 'px';
      } else {
        watermarkEl.style.fontSize = base + 'px';
      }
      requestAnimationFrame(() => moveWatermark());
    });
  });

  const resizes = fromEvent(window, 'resize');
  const debouncedResize = resizes.pipe(debounceTime(300));
  debouncedResize.subscribe(() => {
    // 리사이즈 시 폰트를 기준 크기로 초기화한 후 재배치

    let isMobile = document.body.offsetWidth < 768 && isMobileUtil();
    const list = document.querySelectorAll<HTMLElement>('.watermark');
    list.forEach((el) => {
      const base = parseFloat(el.dataset.baseFontSize || `${fontSize}`);
      el.style.fontSize = `${isMobile ? base * 0.6 : base}px`;
    });
    requestAnimationFrame(() => moveWatermark());
  });
};
export default addWatermark;
